import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import {
  defaultPageInitialContent,
  defaultPageProperties,
} from "../_defaultPageEditingConfig";
import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";

const user = await Scrivito.load(() => Scrivito.currentEditor());
const isAdmin =
  user?.teamsData?.filter((team) => team.name === "Administrators").length > 0;

Scrivito.provideEditingConfig("CoursePage", {
  hideInSelectionDialogs: !isAdmin,
  title: "Course Page",
  attributes: localizeAttrList(
    [
      ...defaultPageProperties,
      ...metadataPropertiesGroup.properties,
      "shortTitle",
      "orientation",
      "degree",
      "semester",
      "credits",
      "lang",
      "courseFilterLang",
      "doesMatchAllLanguages",
      "tuitionFee",
      "location",
      "customLocation",
      "form",
      "start",
      "customStart",
      "deadline",
      "customDeadline",
      "hideOnCourseFinderPage",
      "factsheet",
      "courseDescription",
      "courseWorkload",
    ],
    "CoursePage"
  ),
  properties: [...defaultPageProperties],
  propertiesGroups: [
    socialCardsPropertiesGroup,
    metadataPropertiesGroup,
    {
      title: "Course",
      properties: [
        "shortTitle",
        "courseDescription",
        "courseWorkload",
        "orientation",
        "degree",
        "semester",
        "creditsStandard",
        "credits",
        "lang",
        "doesMatchAllLanguages",
        "tuitionFee",
        "location",
        "customLocation",
        "form",
        "start",
        "customStart",
        "deadline",
        "customDeadline",
        "hideOnCourseFinderPage",
        "courseFilterLang",
        "admissionType",
        "additionalDeadlineInfo",
        "additionalCreditsInfo",
        "additionalLocationInfo",
        "additionalLangInfo",
        "additionalDegreeInfo",
        "additionalStartInfo",
        "additionalFormInfo",
        "additionalCourseWorkloadInfo",
        "additionalTuitionFeeInfo",
        "additionalOrientationInfo",
      ],
    },
  ],
  initialContent: {
    ...defaultPageInitialContent,
    ...metadataInitialContent,
    title: "New Course Page",
    doesMatchAllLanguages: "no",
  },
});
